import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  sectionContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: theme.spacing(1),
  },
  createdAtDate: {
    fontSize: theme.spacing(1.75),
    color: theme.palette.labraText.tertiary,
    lineHeight: theme.spacing(3),
  },
  createdAtTime: {
    fontSize: theme.spacing(1.75),
    color: theme.palette.labraText.description,
    lineHeight: theme.spacing(2.5),
  },
  dateTimeWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  pricingSectionContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: theme.spacing(3),
    gap: theme.spacing(3),
  },
  planCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    backgroundColor: theme.palette.bg.main,
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  emptyState: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(4),
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.labraText.description,
  },
  divider: {
    color: theme.palette.dividerV2.main,
  },
  subHeading: {
    fontSize: '16px',
    fontWeight: 500,
    color: theme.palette.labraText.primary,
    lineHeight: '24px',
  },
  errorSubContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  offerUpdatedAt: {
    fontSize: '11px',
    fontWeight: 500,
    color: theme.palette.labraText.description,
    lineHeight: '16px',
  },
  fullWidthStatusBar: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  fullWidthStatusBarWithExpiration: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  statusText: {
    fontSize: '14px',
    fontWeight: 400,
  },
  combinedFormHeader: {
    backgroundColor: theme.palette.stages.default,
    padding: theme.spacing(3, 4),
    borderRadius: theme.spacing(1),
  },
}))
